// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Wcas","left":"InfoRow_left__1CR_T"};